<template>
    <page-layout>
        <template #header>
            <page-title title="Your Task" :hide-close-button="true" />
        </template>
        <g-loader v-if="isLoading" type="fixed" />
        <template v-else>
            <g-typography
                tag="h3"
                size="h4"
                font-weight="bold"
                margin-class="mb-4"
                value="Delivered Content"
                :margins="true"
            />

            <g-typography
                tag="h4"
                value="Please add metrics to the following delivered content"
                color="red-4"
                margin-class="mb-4"
                :margins="true"
            />

            <base-box v-if="content.incomplete.length" class="g-mb-6">
                <template #content>
                    <g-typography
                        tag="h3"
                        font-weight="bold"
                        margin-class="mb-2"
                        value="Incomplete Content"
                        :margins="true"
                    />
                    <div v-for="incompleteContent in content.incomplete" :key="incompleteContent.id" class="g-mb-4">
                        <activation-content
                            :type="task.type"
                            :url="incompleteContent.content.url"
                            :thumbnail="getThumbnail(task, incompleteContent)"
                            :date="incompleteContent.created_at"
                            :content-id="incompleteContent.id"
                            :network-id="incompleteContent.network_id"
                            :hide-actions="true"
                        />

                        <div class="g-mb-4 g-mt-4 text-center">
                            <g-typography
                                v-if="hasProcessingAiJob(incompleteContent)"
                                color="orange-4"
                                value="Your metrics are currently being processed"
                            />
                            <g-button
                                v-else
                                shape="round"
                                theme="live"
                                block
                                type="primary"
                                @click.prevent="() => handleGoToContent(incompleteContent.id)"
                            >
                                Add Metrics
                            </g-button>
                        </div>
                    </div>
                </template>
            </base-box>

            <base-box v-if="content.complete.length">
                <template #content>
                    <g-typography
                        tag="h3"
                        font-weight="bold"
                        margin-class="mb-2"
                        value="Complete Content"
                        :margins="true"
                    />
                    <div v-for="completeContent in content.complete" :key="completeContent.id" class="g-mb-4">
                        <activation-content
                            :type="task.type"
                            :url="completeContent.content.url"
                            :thumbnail="getThumbnail(task, completeContent)"
                            :date="completeContent.created_at"
                            :content-id="completeContent.id"
                            :network-id="completeContent.network_id"
                            :hide-actions="true"
                        />
                        <g-button
                            shape="round"
                            theme="live"
                            block
                            type="default"
                            class="g-mb-4 g-mt-4"
                            @click.prevent="() => handleGoToContent(completeContent.id)"
                        >
                            Update
                        </g-button>
                    </div>
                </template>
            </base-box>
        </template>
    </page-layout>
</template>

<script>
    import PageLayout from '../../../../layouts/PageLayout.vue';
    import PageTitle from '../../../../library/PageTitle.vue';
    import ActivationContent from '../../../../library/ActivationContent.vue';
    import BaseBox from '../../../../library/BaseBox.vue';
    import { getThumbnail } from '../../../../../helpers/activations/content-thumbnail';

    const AI_JOB_PENDING_STATUS = ['queued', 'running'];

    export default {
        name: 'ActivationDeliveredContentView',
        methods: { getThumbnail },

        components: {
            ActivationContent,
            PageLayout,
            PageTitle,
            BaseBox
        },

        props: {
            task: {
                type: Object,
                default: null
            },
            isLoading: {
                type: Boolean,
                default: false
            },
            content: {
                type: Object,
                default: () => ({
                    complete: [],
                    incomplete: []
                })
            }
        },

        setup(props, { emit }) {
            const handleGoToContent = (contentId) => {
                emit('go-to-content', contentId);
            };

            const hasPendingAiJob = (content) => {
                return AI_JOB_PENDING_STATUS.includes(content.ai_parsing_job_status);
            };

            return {
                handleGoToContent,
                hasProcessingAiJob: hasPendingAiJob
            };
        }
    };
</script>
